module.exports = __webpack_public_path__ + "e04e76278ab689533c28f59f190e1055.svg";